export const ERROR_CONSTANTS = {
  401: {
    title: 'Oops! Your session has expired.',
    message: 'We apologize for the inconvenience. Please log in below or return to the <a href="/">homepage</a>. If you\'re unable to log in, please contact our support team.',
    image: require('./assets/Ghost.svg'),
  },
  404: {
    title: 'Oops! We couldn\'t find that page',
    message: 'We apologize for the inconvenience, please contact our support team or return to the homepage.',
    image: require('./assets//UFO.svg'),
  },
  500: {
    title: 'Oops! It looks like something didn\'t go as planned',
    message: 'We apologize for the inconvenience, please try again later or return to the homepage.',
    image: require('./assets/Error.svg'),
  },
};
